import { useSpring, animated } from '@react-spring/web'
import * as React from 'react'

/* -------------------------------------------------------------------------------------------------
 * AnimatedLogo
 * -----------------------------------------------------------------------------------------------*/

enum TEST_ID {
	logo = 'logo',
}

type AnimatedLogoProps = {
	width?: number
	height?: number
}

const AnimatedLogo: React.FC<AnimatedLogoProps> = (props) => {
	const { width = 60, height = 60 } = props

	const springProps = useSpring({
		from: {
			opacity: 0.2,
		},
		to: {
			opacity: 1,
		},
		config: {
			duration: 7400,
		},
	})

	return (
		<Logo
			data-testid={TEST_ID.logo}
			width={width}
			height={height}
			props={springProps}
			paths={[
				'stroke-accent-8 fill-brown-10',
				'stroke-accent-8 fill-brown-10',
				'stroke-accent-8 fill-brown-10',
				'stroke-accent-8 fill-brown-10',
				'stroke-accent-8 fill-brown-10',
				'stroke-accent-8 fill-brown-10',
				'stroke-accent-8 fill-brown-10',
				'stroke-accent-8 fill-brown-10',
				'stroke-accent-8 fill-brown-10',
				'text-[3rem] font-extralight font-["Roboto-Thin, Roboto"] stroke-accent-12',
				'text-[3rem] font-extralight font-["Roboto-Thin, Roboto"] stroke-accent-12',
				'text-[3rem] font-extralight font-["Roboto-Thin, Roboto"] stroke-accent-12',
				'text-[3rem] font-extralight font-["Roboto-Thin, Roboto"] stroke-accent-12',
				'text-[3rem] font-extralight font-["Roboto-Thin, Roboto"] stroke-accent-12',
				'text-[3rem] font-extralight font-["Roboto-Thin, Roboto"] stroke-accent-12',
				'text-[3rem] font-extralight font-["Roboto-Thin, Roboto"] stroke-accent-12',
				'text-[3rem] font-extralight font-["Roboto-Thin, Roboto"] stroke-accent-12',
				'text-[3rem] font-extralight font-["Roboto-Thin, Roboto"] stroke-accent-12',
				'text-[3rem] font-extralight font-["Roboto-Thin, Roboto"] stroke-accent-12',
				'text-[3rem] font-extralight font-["Roboto-Thin, Roboto"] stroke-accent-12',
				'text-[3rem] font-extralight font-["Roboto-Thin, Roboto"] stroke-accent-12',
				'text-[3rem] font-extralight font-["Roboto-Thin, Roboto"] stroke-accent-12',
				'stroke-brown-10', // ??
				'stroke-accent-8 fill-accent-11',
				'stroke-accent-8 fill-accent-11',
				'stroke-accent-8 fill-accent-11',
				'stroke-accent-8 fill-accent-11',
				'stroke-accent-8 fill-accent-11',
				'stroke-accent-8 fill-accent-11',
				'stroke-accent-8 fill-accent-11',
				'stroke-accent-8 fill-accent-11',
				'stroke-accent-8 fill-accent-11',
				'stroke-accent-8 fill-accent-11',
				'stroke-accent-8 fill-accent-11',
				'stroke-accent-8 fill-accent-11',
				'stroke-accent-8 fill-accent-11',
				'stroke-accent-8 fill-accent-11',
				'stroke-accent-8 fill-accent-11',
				'stroke-accent-8 fill-accent-11',
				'stroke-accent-8 fill-accent-11',
				'stroke-accent-8 fill-accent-11',
				'stroke-accent-8 fill-accent-11',
				'stroke-accent-8 fill-accent-11',
				'stroke-accent-8 fill-accent-11',
				'stroke-brown-10',
				'stroke-brown-5 fill-brown-10 stroke-[4]', // hand
				'stroke-brown-10 fill-brown-10', // ??
			]}
		/>
	)
}
AnimatedLogo.displayName = 'AnimatedLogo'

/* -------------------------------------------------------------------------------------------------
 * Logo
 * -----------------------------------------------------------------------------------------------*/

const Logo: React.FC<any> = ({ ...props }) => (
	<svg
		data-testid={TEST_ID.logo}
		id="Logo"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 797.35 975.64"
		{...props}
	>
		<path
			className={props.paths?.[0] || ''}
			d="M626.38,558.68"
			transform="translate(-120.24 -79.51)"
		/>
		<path
			className={props.paths?.[1] || ''}
			d="M488,902.1a23.84,23.84,0,0,1-2.14-2.47C486.55,900.46,487.27,901.29,488,902.1Z"
			transform="translate(-120.24 -79.51)"
		/>
		<path
			className={props.paths?.[2] || ''}
			d="M475.38,884.12c.6,1.26,1.26,2.5,2,3.73ZM423.7,922.4c1.09,2.5,2.29,5,3.57,7.4C426.07,927.41,424.88,924.92,423.7,922.4Zm51.68-38.28c.6,1.26,1.26,2.5,2,3.73Z"
			transform="translate(-120.24 -79.51)"
		/>
		<path
			className={props.paths?.[3] || ''}
			d="M897.16,187.7c-7.54-6.94-20.24-4.19-28.67-10-3.4-2.34-5.81-5.91-9.23-8.22-4.35-2.92-9.81-3.5-15-4.14a280.87,280.87,0,0,1-96-30c-15.92-8.36-31.16-18.3-48.17-24.1-14.57-5-30.18-6.82-44.21-13.15-9-4-22.46-13.6-31.85-16.58-25.21-8-46.2,9.67-69.75,21.7a613,613,0,0,1-124,47.19c-18.91,4.93-38.09,9-56.69,15a280.75,280.75,0,0,0-135.7,96.32s0,0,0,0C172.34,338.4,129.1,435,121.55,535.52a482.18,482.18,0,0,0,71.09,288.89c47.22,75.74,115.87,137.66,195.21,178.49,81.25,41.82,175.43,61.34,265.45,48.18a214,214,0,0,0,56.06-11.42c18.21-6.18,44.45-18.36,69.43-33.05,27.33-16.08,55.67-33.11,72.78-59.8-48.87,49.69-123.2,70.51-189.28,53.71C648.51,997,635.17,992,621.88,987c-21.3-8.12-42.6-16.5-62.57-27.5a265.84,265.84,0,0,1-67.64-53.27l-.27-.31c-1.16-1.25-2.29-2.51-3.41-3.79a23.84,23.84,0,0,1-2.14-2.47h0c-.29-.34-.56-.68-.85-1a79.43,79.43,0,0,1-7.65-10.76c-.71-1.23-1.37-2.47-2-3.73l-.09-.18a46.25,46.25,0,0,1-4.45-19.12c-.37-14.08,4.86-28.38,14.88-38.28h0c10.39-8.75,22.71-13.44,35-12.31,23.05,2.13,42.53,22,63.19,35.69,14.22,9.39,29.86,16.09,45.77,15.42s32.1-9.47,41.58-26.29c-13.28,12-30.43,15.18-46.33,11.63s-30.65-13.29-44-25.17c-12.46-11.08-24.1-24.23-38-31.74-22.88-12.35-50-7.51-71.21,9.23a73.47,73.47,0,0,0-22.94,30.84q-.51-2.66-.81-5.36c-.93-8.32-.37-16.72.45-25A391.43,391.43,0,0,1,456.06,756c26-76.25,105.2-126.82,185.17-129.36S799,664.91,851.34,725.47a331.92,331.92,0,0,0-97.8-106.54c-29.55-20.54-63.39-36.46-99.28-38.86-17.74-1.18-35.56,1-53,4.35a336.42,336.42,0,0,0-37.5,9.51c.53-15.41-3.33-31.13-6.25-46.48-5.84-30.71-7.72-63.34,3.64-92.45,9.5-24.34,27.72-44.53,48.71-60.07s44.81-26.81,68.71-37.35c-28.31,10-56.81,20.26-82.35,36.05S548,431.37,536.53,459.12C522.75,492.43,526.33,530,527.24,566c.31,11.93.24,24.15-3.73,35.41A44.89,44.89,0,0,1,517.44,613,238.34,238.34,0,0,0,465,649.49,202,202,0,0,0,445,671c-1.12-13.31-4.7-26.43-8.91-39.16-8.8-26.55-20.62-52.4-38-74.34s-40.54-39.85-67.37-47.74c21.8,9.58,39.27,27.35,51.83,47.59s20.55,43,27.27,65.79c8.58,29.15,15,60.93,8.66,90-27.07,56.42-30.77,124.47-6.76,182.51q2.58,6.25,5.55,12.32,1.68,3.48,3.5,6.9c.82,2.49,1.78,4.94,2.84,7.35l.06.14c1.18,2.52,2.37,5,3.57,7.4l.08.16c2.63,5,5.56,9.92,8.49,14.85a202.41,202.41,0,0,1,11.87,22c4.38,10,4.19,25.71-6.58,27.41-4.21.66-8.33-1.44-12.06-3.51-45.73-25.46-87-58.46-123.79-95.71-49.71-50.37-92.11-110.32-109.76-178.85-6.39-24.83-9.45-50.43-10.29-76.06a450.62,450.62,0,0,1,56.39-232.67c18.56-33.29,37.54-60.12,72.55-89.13h0c27.95-19,57.3-39.78,90.86-39.23,27,.45,52.63,15,79.57,13.23,35.93-2.36,63.56-32.44,97.52-44.44,28.07-9.92,59.14-7,88-14.46,18-4.66,34.74-13.29,50.75-22.76a92.32,92.32,0,0,1,13-6.88,32.18,32.18,0,0,1,7.89-2.05c6.07-.71,12.18.76,18.14,2.15a892,892,0,0,0,96.41,17c11.67,1.4,24.26,2.39,34.39-3.55S905.8,195.64,897.16,187.7ZM224.1,281.57c1.93-4.15,3.26-6,4.28-6.57C226.92,277.16,225.49,279.36,224.1,281.57Z"
			transform="translate(-120.24 -79.51)"
		/>
		<path
			className={props.paths?.[4] || ''}
			d="M228.38,275c-1.46,2.16-2.89,4.36-4.28,6.57C226,277.42,227.36,275.54,228.38,275Z"
			transform="translate(-120.24 -79.51)"
		/>
		<path
			className={props.paths?.[5] || ''}
			d="M605.36,1045.34"
			transform="translate(-120.24 -79.51)"
		/>
		<path
			className={props.paths?.[6] || ''}
			transform="translate(-120.24 -79.51)"
		/>
		<path
			className={props.paths?.[7] || ''}
			d="M423.64,922.26c-2.23-4.77-4.39-9.66-6.34-14.25q1.68,3.48,3.5,6.9C421.62,917.4,422.58,919.85,423.64,922.26Z"
			transform="translate(-120.24 -79.51)"
		/>
		<path
			className={props.paths?.[8] || ''}
			d="M435.84,944.81A125.87,125.87,0,0,1,427.35,930C430,935,432.91,939.88,435.84,944.81Z"
			transform="translate(-120.24 -79.51)"
		/>
		<text
			className={props.paths?.[9] || ''}
			transform="matrix(0.59, -0.81, 0.81, 0.59, 386.4, 683.45)"
		>
			s
		</text>
		<text
			className={props.paths?.[10] || ''}
			transform="translate(403.99 659.98) rotate(-41.19)"
		>
			u
		</text>
		<text
			className={props.paths?.[11] || ''}
			transform="translate(428.21 638.71) rotate(-26.29)"
		>
			w
		</text>
		<text
			className={props.paths?.[12] || ''}
			transform="translate(466.52 620.95) rotate(-16.1)"
		>
			e
		</text>
		<text
			className={props.paths?.[13] || ''}
			transform="translate(494.44 613.47) rotate(-9.76)"
		>
			-
		</text>
		<text
			className={props.paths?.[14] || ''}
			transform="matrix(1, -0.06, 0.06, 1, 508.76, 610.76)"
		>
			K
		</text>
		<text
			className={props.paths?.[15] || ''}
			transform="translate(536.46 609.45) rotate(4.76)"
		>
			o
		</text>
		<text
			className={props.paths?.[16] || ''}
			transform="translate(561.13 611.75) rotate(12.02)"
		>
			s
		</text>
		<text
			className={props.paths?.[17] || ''}
			transform="translate(583.63 616.17) rotate(21.01)"
		>
			m
		</text>
		<text
			className={props.paths?.[18] || ''}
			transform="translate(619.29 630.87) rotate(27.75)"
		>
			e
		</text>
		<text
			className={props.paths?.[19] || ''}
			transform="matrix(0.83, 0.55, -0.55, 0.83, 639.36, 641.6)"
		>
			t
		</text>
		<text
			className={props.paths?.[20] || ''}
			transform="translate(651.74 650.06) rotate(36.83)"
		>
			i
		</text>
		<text
			className={props.paths?.[21] || ''}
			transform="matrix(0.77, 0.64, -0.64, 0.77, 660.24, 656.3)"
		>
			k
		</text>
		<path
			className={props.paths?.[22] || ''}
			d="M228.38,275c-1.46,2.16-2.89,4.36-4.28,6.57C226,277.42,227.36,275.54,228.38,275Z"
			transform="translate(-120.24 -79.51)"
		/>
		<animated.path
			className={props.paths?.[23] || ''}
			d="M765.41,324.45a272.35,272.35,0,0,0-45-5.3c-10.47-.34-21.4.14-29.23,6.22a26.11,26.11,0,0,0-9.4,16.68,26.79,26.79,0,0,0,.44,10.88c2.94,11.25,14.28,19.66,24.64,21s19.67-3,27.53-8.71C747.76,355.51,758.31,341.72,765.41,324.45Z"
			transform="translate(-120.24 -79.51)"
			style={props.props}
		/>
		<animated.path
			className={props.paths?.[24] || ''}
			d="M473.71,384.26a272.61,272.61,0,0,0,8.67,44.52c2.87,10.08,6.65,20.34,14.82,25.94A26.12,26.12,0,0,0,516,458.6a26.67,26.67,0,0,0,10.23-3.74c9.81-6.22,14.37-19.58,12.46-29.84S529.76,407.2,522,401.45C508.67,391.61,492.32,385.77,473.71,384.26Z"
			transform="translate(-120.24 -79.51)"
			style={props.props}
		/>
		<animated.path
			className={props.paths?.[25] || ''}
			d="M671.71,285.61a271.43,271.43,0,0,0-40.09,21.19c-8.82,5.67-17.54,12.26-20.54,21.71a26.07,26.07,0,0,0,1.72,19.07,26.85,26.85,0,0,0,6.54,8.71c8.8,7.59,22.91,8.08,32.18,3.28s14.47-13.67,17.73-22.8C674.8,321.19,675.66,303.86,671.71,285.61Z"
			transform="translate(-120.24 -79.51)"
			style={props.props}
		/>
		<animated.path
			className={props.paths?.[26] || ''}
			d="M574.25,309.8a271.75,271.75,0,0,0-28.79,35c-6,8.63-11.45,18.09-10.56,28a26.08,26.08,0,0,0,9,16.92,26.59,26.59,0,0,0,9.39,5.51c11,3.6,24.26-1.4,31-9.41s8.06-18.2,7.54-27.87C590.85,341.43,584.94,325.11,574.25,309.8Z"
			transform="translate(-120.24 -79.51)"
			style={props.props}
		/>
		<animated.path
			className={props.paths?.[27] || ''}
			d="M733.38,395.14A273,273,0,0,0,692.74,375c-9.75-3.84-20.2-7.06-29.62-4a26.12,26.12,0,0,0-14.46,12.55,26.69,26.69,0,0,0-3.24,10.4c-1,11.58,6.84,23.31,16.15,28s19.56,3.75,28.86,1.05C706.32,418.46,720.88,409,733.38,395.14Z"
			transform="translate(-120.24 -79.51)"
			style={props.props}
		/>
		<animated.path
			className={props.paths?.[28] || ''}
			d="M657,760.43a272.34,272.34,0,0,0-44.12,10.51c-10,3.29-20,7.49-25.31,15.89a26.08,26.08,0,0,0-3.09,18.9,26.56,26.56,0,0,0,4.16,10.06c6.62,9.55,20.16,13.55,30.33,11.22s17.43-9.63,22.86-17.65C651.09,795.66,656.25,779.09,657,760.43Z"
			transform="translate(-120.24 -79.51)"
			style={props.props}
		/>
		<animated.path
			className={props.paths?.[29] || ''}
			d="M726,879.12a272.32,272.32,0,0,0-43.13-14c-10.21-2.38-21-4-29.88.38A26,26,0,0,0,640.54,880a26.66,26.66,0,0,0-1.7,10.76c.68,11.6,10.16,22.07,20.06,25.37s19.89.86,28.7-3.16C702.65,906.13,715.69,894.67,726,879.12Z"
			transform="translate(-120.24 -79.51)"
			style={props.props}
		/>
		<animated.path
			className={props.paths?.[30] || ''}
			d="M738.9,773.8a272,272,0,0,0-44.45,9c-10.06,3-20.29,6.81-25.84,15a26.1,26.1,0,0,0-3.73,18.78,26.56,26.56,0,0,0,3.81,10.2C675,836.56,688.38,841,698.63,839s17.74-9,23.44-16.86C731.81,808.81,737.53,792.42,738.9,773.8Z"
			transform="translate(-120.24 -79.51)"
			style={props.props}
		/>
		<animated.path
			className={props.paths?.[31] || ''}
			d="M644.06,921.74a272.24,272.24,0,0,0-23.11-39c-6.09-8.53-13.1-16.92-22.67-19.46a26,26,0,0,0-19,2.65,26.57,26.57,0,0,0-8.38,7c-7.16,9.15-7,23.27-1.72,32.3s14.35,13.79,23.63,16.6C608.66,926.54,626,926.56,644.06,921.74Z"
			transform="translate(-120.24 -79.51)"
			style={props.props}
		/>
		<animated.path
			className={props.paths?.[32] || ''}
			d="M552.9,896.62a270.46,270.46,0,0,0-7.76-44.69c-2.66-10.13-6.23-20.47-14.28-26.24a26.14,26.14,0,0,0-18.67-4.26A26.72,26.72,0,0,0,501.88,825c-9.94,6-14.77,19.29-13.07,29.58s8.53,18,16.2,23.91C518.11,888.55,534.33,894.73,552.9,896.62Z"
			transform="translate(-120.24 -79.51)"
			style={props.props}
		/>
		<animated.path
			className={props.paths?.[33] || ''}
			d="M917.59,699.77a271.66,271.66,0,0,0-29.19-34.7c-7.41-7.42-15.7-14.56-25.56-15.49a26.07,26.07,0,0,0-18.27,5.72,26.64,26.64,0,0,0-7.13,8.23c-5.57,10.21-3.06,24.1,3.59,32.15s16.43,11.25,26,12.5C883.46,710.32,900.59,707.49,917.59,699.77Z"
			transform="translate(-120.24 -79.51)"
			style={props.props}
		/>
		<animated.path
			className={props.paths?.[34] || ''}
			d="M866.36,623.13a272.19,272.19,0,0,0-37.84-25c-9.2-5-19.18-9.5-28.9-7.6a26,26,0,0,0-15.9,10.67,26.55,26.55,0,0,0-4.5,9.91c-2.44,11.37,3.9,24,12.56,29.81s18.94,6.13,28.51,4.61C836.62,642.92,852.24,635.35,866.36,623.13Z"
			transform="translate(-120.24 -79.51)"
			style={props.props}
		/>
		<animated.path
			className={props.paths?.[35] || ''}
			d="M667.59,446.77a272.42,272.42,0,0,0-41.89-17.39c-10-3.18-20.62-5.7-29.81-2a26.13,26.13,0,0,0-13.6,13.49,26.73,26.73,0,0,0-2.54,10.59c-.24,11.62,8.38,22.8,18,26.88s19.76,2.44,28.87-.87C642.14,471.83,656,461.44,667.59,446.77Z"
			transform="translate(-120.24 -79.51)"
			style={props.props}
		/>
		<animated.path
			className={props.paths?.[36] || ''}
			d="M802.25,547.39A272,272,0,0,0,757,544.7c-10.47.27-21.35,1.38-28.81,7.9a26.07,26.07,0,0,0-8.42,17.2,26.62,26.62,0,0,0,1.07,10.84c3.58,11.06,15.39,18.79,25.8,19.5s19.47-4.18,27-10.29C786.43,579.41,796.15,565,802.25,547.39Z"
			transform="translate(-120.24 -79.51)"
			style={props.props}
		/>
		<animated.path
			className={props.paths?.[37] || ''}
			d="M720.77,504.73a272.78,272.78,0,0,0-44.93,6.18c-10.22,2.3-20.68,5.51-26.73,13.35a26.13,26.13,0,0,0-4.91,18.51,26.67,26.67,0,0,0,3.16,10.42c5.66,10.15,18.75,15.45,29.1,14.11s18.28-7.89,24.47-15.35C711.48,539.22,718.23,523.23,720.77,504.73Z"
			transform="translate(-120.24 -79.51)"
			style={props.props}
		/>
		<animated.path
			className={props.paths?.[38] || ''}
			d="M245.78,476.35A271,271,0,0,0,275.06,511c7.42,7.41,15.72,14.52,25.59,15.43a26.07,26.07,0,0,0,18.26-5.76,26.67,26.67,0,0,0,7.11-8.25c5.54-10.22,3-24.11-3.67-32.13s-16.45-11.22-26.06-12.45C279.89,465.73,262.77,468.6,245.78,476.35Z"
			transform="translate(-120.24 -79.51)"
			style={props.props}
		/>
		<animated.path
			className={props.paths?.[39] || ''}
			d="M272,563.06a271.73,271.73,0,0,0,42.61,15.52c10.12,2.74,20.86,4.78,29.88.67a26.06,26.06,0,0,0,13-14.07,26.68,26.68,0,0,0,2.08-10.69c-.27-11.62-9.38-22.42-19.15-26.07s-19.85-1.56-28.8,2.15C296.29,536.9,282.86,547.89,272,563.06Z"
			transform="translate(-120.24 -79.51)"
			style={props.props}
		/>
		<animated.path
			className={props.paths?.[40] || ''}
			d="M345.31,441.74a271.56,271.56,0,0,0,4.41,45.14c1.91,10.3,4.7,20.88,12.3,27.23a26.06,26.06,0,0,0,18.31,5.63A26.58,26.58,0,0,0,390.86,517c10.37-5.26,16.17-18.13,15.24-28.53s-7.17-18.57-14.38-25C379.41,452.37,363.69,445,345.31,441.74Z"
			transform="translate(-120.24 -79.51)"
			style={props.props}
		/>
		<animated.path
			className={props.paths?.[41] || ''}
			d="M426.08,480.77a272.62,272.62,0,0,0-15.37,42.67c-2.7,10.12-4.71,20.87-.57,29.87a26.09,26.09,0,0,0,14.12,12.94,26.53,26.53,0,0,0,10.7,2c11.62-.31,22.38-9.45,26-19.24s1.49-19.85-2.25-28.79C452.33,505,441.29,491.6,426.08,480.77Z"
			transform="translate(-120.24 -79.51)"
			style={props.props}
		/>
		<animated.path
			className={props.paths?.[42] || ''}
			d="M492.26,544.62a272,272,0,0,0-36.19,27.32c-7.8,7-15.36,14.91-16.81,24.71A26,26,0,0,0,444,615.2a26.45,26.45,0,0,0,7.84,7.55c9.9,6.09,23.91,4.32,32.29-1.89s12.1-15.81,13.86-25.34C501,579.25,499.07,562,492.26,544.62Z"
			transform="translate(-120.24 -79.51)"
			style={props.props}
		/>
		<animated.path
			className={props.paths?.[43] || ''}
			d="M309.39,605.89a271.83,271.83,0,0,0,35,28.8c8.63,5.94,18.09,11.44,27.95,10.56a26.11,26.11,0,0,0,16.93-9,26.61,26.61,0,0,0,5.5-9.4c3.61-11-1.39-24.25-9.4-30.94s-18.2-8.07-27.87-7.55C341,589.3,324.7,595.21,309.39,605.89Z"
			transform="translate(-120.24 -79.51)"
			style={props.props}
		/>
		<animated.path
			className={props.paths?.[44] || ''}
			d="M491.4,905.89c-1.16-1.25-2.29-2.51-3.41-3.79C489.09,903.29,490.41,904.72,491.4,905.89Z"
			transform="translate(-120.24 -79.51)"
			style={props.props}
		/>
		<path
			className={props.paths?.[45] || ''}
			d="M485.93,174.16c12.31-7.73,29.09-8.5,44.36-6.64s30.11,6,45.51,7c12,.77,24-.39,35.87-1.54l59.39-5.77c17.9-1.73,36.58-3.4,53.49,1.76,4.78,1.46,9.43,3.52,12.79,6.69a16.9,16.9,0,0,1,4.07,18.73c-2.58,6.29-8.81,11.34-16.2,13.89"
			transform="translate(-120.24 -79.51)"
		/>
		<path
			className={props.paths?.[46] || ''}
			d="M449.48,794.05s2.59-37.95,21.28-69.82-24.22-15.13-24.22-15.13l-19.27,76.38Z"
			transform="translate(-120.24 -79.51)"
		/>
	</svg>
)
Logo.displayName = 'Logo'

/* -----------------------------------------------------------------------------------------------*/

export { AnimatedLogo, Logo, TEST_ID as LOGO_TEST_ID }
